import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocalizedDateStrings } from './useLocalizedDateStrings';

export const useLocalizedDatepicker = () => {
  const { t } = useTranslation();
  const localizedDateStrings = useLocalizedDateStrings();

  return useMemo(
    () => ({
      ...localizedDateStrings,
      shortMonths: [
        t('january_short', { defaultValue: 'Jan' }),
        t('february_short', { defaultValue: 'Feb' }),
        t('march_short', { defaultValue: 'Mär' }),
        t('april_short', { defaultValue: 'Apr' }),
        t('may_short', { defaultValue: 'Mai' }),
        t('june_short', { defaultValue: 'Jun' }),
        t('july_short', { defaultValue: 'Jul' }),
        t('august_short', { defaultValue: 'Aug' }),
        t('september_short', { defaultValue: 'Sep' }),
        t('october_short', { defaultValue: 'Okt' }),
        t('november_short', { defaultValue: 'Nov' }),
        t('december_short', { defaultValue: 'Dez' }),
      ],
      goToToday: t('go_to_today', { defaultValue: 'Heute' }),
      openCalendarTitle: t('open_calendar', { defaultValue: 'Kalender öffnen' }),
      inputPlaceholder: t('select_a_date_placeholder', { defaultValue: 'Datum auswählen...' }),
      weekNumberFormatString: t('week_number_format_string', {
        defaultValue: 'Kalenderwoche {0}',
      }),
      prevMonthAriaLabel: t('previous_month', { defaultValue: 'Wechsel zum vorheriger Monat' }),
      nextMonthAriaLabel: t('next_month', { defaultValue: 'Wechsel zum nächsten Monat' }),
      prevYearAriaLabel: t('previous_year', { defaultValue: 'Vorheriges Jahr' }),
      nextYearAriaLabel: t('next_year', { defaultValue: 'Nächstes Jahr' }),
      prevYearRangeAriaLabel: t('previous_year_range', {
        defaultValue: 'Vorherige Jahresspanne',
      }),
      nextYearRangeAriaLabel: t('next_year_range', { defaultValue: 'Nächste Jahresspanne' }),
      closeButtonAriaLabel: t('close', { defaultValue: 'Schließen' }),
      selectedDateFormatString: t('selected_date_format', {
        defaultValue: 'Ausgewähltes Datum {0}',
      }),
      todayDateFormatString: t('today_date_format', { defaultValue: 'Heutiges Datum {0}' }),
      monthPickerHeaderAriaLabel: t('month_picker_header_aria_format', {
        defaultValue: '{0}, auswählen um das Jahr zu ändern',
      }),
      yearPickerHeaderAriaLabel: t('year_picker_header_aria_format', {
        defaultValue: '{0}, auswählen um den Monat zu ändern',
      }),
      isRequiredErrorMessage: t('date_selection_is_required', {
        defaultValue: 'Es muss ein Datum ausgewählt sein.',
      }),
      invalidInputErrorMessage: t('manual_date_input_is_not_valid', {
        defaultValue: 'Das eingegebene Datumsformat ist nicht korrekt.',
      }),
      isOutOfBoundsErrorMessage: t('date_is_out_of_bounds', {
        defaultValue: 'Das ausgewählte Datum ist außerhalb des gültigen Bereichs.',
      }),
      inputBoundedFormatString: t('input_bounded_format', {
        defaultValue: 'Geben Sie ein Datum zwischen {0} und {1} an.',
      }),
      inputMaxBoundedFormatString: t('input_max_format', {
        defaultValue: 'Geben Sie ein Datum an welches am {0} endet.',
      }),
      inputMinBoundedFormatString: t('input_min_format', {
        defaultValue: 'Geben Sie ein Datum an welches am {0} startet.',
      }),
    }),
    [localizedDateStrings, t],
  );
};
